import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Query, Result, } from "../../../../interfaces";
import { Find } from "../../../products";
import { Adapter } from "../../../../shared/adapter";
import { GroupAdapter } from "../../../../adapter/groups-adapter";

export const FETCH_DATA_ME_GROUPS_REQUEST = 'FETCH_DATA_ME_GROUPS_REQUEST';
export const FETCH_DATA_ME_GROUPS_SUCCESS = 'FETCH_DATA_ME_GROUPS_SUCCESS';
export const FETCH_DATA_ME_GROUPS_FAILURE = 'FETCH_DATA_ME_GROUPS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDataMeGroupsRequest = () => {
    return {
        type: FETCH_DATA_ME_GROUPS_REQUEST,
    };
};

const fetchDataMeGroupsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DATA_ME_GROUPS_SUCCESS,
        payload: data
    };
};

const fetchDataMeGroupsFailure = (error: any) => {
    return {
        type: FETCH_DATA_ME_GROUPS_FAILURE,
        payload: error,
    };
};

export const find = (page: number, pageSize: number, query:Query) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDataMeGroupsRequest());
        try {
            const response = await Find('groups', query, page, pageSize);

            dispatch(fetchDataMeGroupsSuccess(
                { 
                    meta : response.meta,
                    values : Adapter.from(response.data).to((value) => new GroupAdapter(value).adapt()) 
                }
            ));

        } catch (error: any) {
            dispatch(fetchDataMeGroupsFailure(error.message));
        }
    };
};
